import { MatSnackBar } from '@angular/material';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/snack-bar";
var CommonNotificationService = /** @class */ (function () {
    function CommonNotificationService(snackBar) {
        this.snackBar = snackBar;
        this.horizontalPosition = 'center';
        this.verticalPosition = 'top';
    }
    CommonNotificationService.prototype.showSnackBar = function (message, type, durationInMs, action) {
        this.snackBar.open(message, action, {
            'duration': durationInMs ? durationInMs : 2000,
            'horizontalPosition': this.horizontalPosition,
            'verticalPosition': this.verticalPosition,
            'panelClass': type
        });
    };
    CommonNotificationService.prototype.closeableSnackBar = function (message, action, durationInMs) {
        var sb = this.snackBar.open(message, action, {
            duration: durationInMs ? durationInMs : 2000,
            'horizontalPosition': 'start',
            'verticalPosition': 'bottom',
            panelClass: ["closeable-snackbar"]
        });
        sb.onAction().subscribe(function () {
            sb.dismiss();
        });
    };
    CommonNotificationService.ngInjectableDef = i0.defineInjectable({ factory: function CommonNotificationService_Factory() { return new CommonNotificationService(i0.inject(i1.MatSnackBar)); }, token: CommonNotificationService, providedIn: "root" });
    return CommonNotificationService;
}());
export { CommonNotificationService };
